import { getWebSocketConnection, createSubscription, disconnectWebSocket, reconnectWebSocket } from '@/services/flowit/websocket';

export default {
  install(Vue) {
    // Adicionar métodos WebSocket globalmente
    Vue.prototype.$websocket = {
      // Criar subscription
      subscribe: createSubscription,
      
      // Obter conexão
      getConnection: getWebSocketConnection,
      
      // Reconectar
      reconnect: reconnectWebSocket,
      
      // Desconectar
      disconnect: disconnectWebSocket
    };
    
    // Mixin global para cleanup automático de subscriptions
    Vue.mixin({
      beforeDestroy() {
        // Automatically cleanup WebSocket subscriptions
        if (this.$options.websocketSubscriptions) {
          this.$options.websocketSubscriptions.forEach(subscription => {
            if (subscription && typeof subscription.unsubscribe === 'function') {
              subscription.unsubscribe();
            }
          });
        }
      }
    });
  }
};